<template>
    <div id="searchView">
        <!--搜索-->
        <topSearchView  @topSearchParentReceive="topSearchParentReceiveFN"/>
        <!--内容-->
        <div class="bottomWrap">
            <!--顶部的路径-->
            <div class="topPathView">
                <p>
                    <span>首页 > </span>
                    <span>{{ editionName }}></span>
                    <span v-for="(item ,index ) in showPathName" :key="index">
                        <span :class="index==showPathName.length-1?'blueSpan':''">{{ item }}</span>
                        <span v-if="index!=showPathName.length-1">></span>
                    </span>
                </p>
            </div> 
            <div class="showView">
                <!--左侧分类的展示-->
                <div class="leftTreeView">
                    <div v-if="sendDataTreeLeft.length!=0">
                        <treeZYView :sendDataTree="sendDataTreeLeft" @treeEmit="treeEmitFN" />
                    </div>

                </div>
                <!--右侧内容-->
                <div class="rightContentView">
                    <!--标签中选中的分类-->
                    <div class="showTreeName">
                        <span>{{ rightShowTreeInfo.name }}</span>
                        <span class="treeCount">({{ rightShowTreeInfo.count }})</span>
                    </div>
                    <!--数据列表-->
                    <div class="dataBox">
                        <listSGView  ref="sgListView" :sendData="sendListData" :sendSearchData="searchSend" @listEmit="listEmitFN" />
                        <!-- <div v-if="searchSend.searchEdition==1">
                            <listView  ref="zyListView" :sendData="sendDataDY"  />
                        </div>
                        <div v-if="searchSend.searchEdition==2">
                            <listSGView ref="sgListView" @listSend="listSendFN" :sendData="sendDataDY" />
                        </div>
                        <div v-if="searchSend.searchEdition==3">
                            <listKJView ref="kjListView" @listSend="listSendFN" :sendData="sendDataDY" />
                        </div>
                        <div v-if="searchSend.searchEdition==6">
                            <listJCALView ref="jcalListView" @listSend="listSendFN" :sendData="sendDataDY" />
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

//引入组件
import topSearchView from '@/components/topSearch.vue'
import treeZYView from '../component/treeZY.vue'
import listSGView from '../component/list_shuigan.vue'

//引入接口
import { categoryCategoryTree } from '@/api/importZSG/api'

export default {
    name:'',
    components:{
        topSearchView,
        treeZYView,
        listSGView,
    },
    data(){
        return{
            //搜索版本名
            editionName:'税干版',
            //loading
            loading:null,
            //搜索框 传递过来的参数 
            searchSend:{},
            //传递给左侧树的数据
            sendDataTreeLeft:[],
            dataAll:[],
            //左侧数据点击后传回来的数据
            leftTreeEmitData:{},
            //传递给左侧的数据 用做查询数据后的回显
            sendNodeId:[],
            //展示的分类名们
            showPathName:['国家税务总局令文件'],
            //右侧展示的选中的名字和数量
            rightShowTreeInfo:{
                name:'国家税务总局令文件',
                count:0,
            },
            //传递给右侧的数据
            sendListData:{
                rootCategoryId:'18767',
                tagCategoryId:'19503',
                categoryId:33554,
                states:[],
            },
        }
    },
    created(){
        //分开判断
        //获取会员及登录信息
        let tUser = sessionStorage.getItem("userInfoData");
        tUser = JSON.parse(tUser)
        //console.log(tUser)
        if(!tUser.id){
            this.$message({
                message:'请您先登录后查看!',
                type:'warning'
            })
            //回到首页
            this.$router.push('/')
        }else{
            //是否是会员
            if(tUser.vipInfo&&tUser.vipInfo.isVip&&tUser.vipInfo.isVip==1){
                console.log(tUser)
            }else{
                this.$message({
                    message:'请您购买会员后查看!',
                    type:'warning'
                })
                //回到首页
                this.$router.push('/')
            }
        }

        //获取传递的参数 params 刷新后消失
        let data = this.$route.params
        this.searchSend = data;
        this.searchSend.searchType = 0

        //获取左侧的数据
        this.getLeftTreeDataFN();
    },
    methods:{
        //搜索框 搜索按钮的点击 -- 子组件传递
        topSearchParentReceiveFN(data){
            //获取点击输入框时传递的一些参数
            //console.log(data)
            this.searchSend = data
            this.searchSend.searchType = 0

            //传递给树的数据 重置
            //this.sendDataTreeLeft = []
            //获取左侧的树数据
            //this.getLeftTreeDataFN();

            //获取右侧列表中的数据:sendData="sendListData" :sendSearchData="searchSend"
            this.$refs.sgListView.getStart(this.sendListData,this.searchSend)
        },

        //左侧树的 回传
        treeEmitFN(data){
            console.log(data);
            //保存一下数据
            this.leftTreeEmitData = data;
            this.sendListData.tagCategoryId = data.id;

            //判断是否是规范性文件
            if(this.sendListData.tagCategoryId == '33659'||this.sendListData.tagCategoryId == '33657'||this.sendListData.tagCategoryId == '33658'){
                this.sendListData.categoryId = 33787
            }else{
                this.sendListData.categoryId = 33554
            }


            //顶部的路径
            this.showPathName = data.pathArr
            //右侧展示的名字和数据条数
            this.rightShowTreeInfo.name = data.name
            //this.rightShowTreeInfo.count = data.count;
            //调用数据
            this.$refs.sgListView.getStart(this.sendListData,this.searchSend)
        },
        //右侧列表的回传
        listEmitFN(data){
            this.rightShowTreeInfo.count = data.count;
        },
        //遍历数据 获取对应的path
        eachDataFN(allList,arr){
            for(let a=0;a<allList.length;a++){
                let pathArr = JSON.parse(JSON.stringify(arr));
                pathArr.push(allList[a].name);
                allList[a].pathArr = pathArr
                if(allList[a].childs&&allList[a].childs.length!=0){
                    this.eachDataFN(allList[a].childs,allList[a].pathArr)
                }
            }
            return allList
        },
        //标签树
        getLeftTreeDataFN(){
            // let data = {
            //     rootCategoryId:'',
            //     categoryType:'zhzsk_zsg_tag_type',
            //     orderField:'sort',
            //     orderType:'desc',
            //     level:4
            // }
            this.loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
            })
            let data = new FormData()
            data.append('rootCategoryId', this.sendListData.rootCategoryId)
            data.append('categoryType', 'zhzsk_zsg_tag_type')
            data.append('orderField', 'sort')
            data.append('orderType', 'desc')
            data.append('level', '4')
            categoryCategoryTree(data).then(res => {
                let tRes = res.data.data

                //2025-09-02 去掉国务院文件
                tRes = tRes.filter(it=>it.id!=33658)

                //tRes = tRes.filter(it=>it.id!=19516)
                tRes = tRes.filter(it=>it.id!=19360)
                tRes = tRes.filter(it=>it.id!=19059)
                tRes = tRes.filter(it=>it.id!=18768)
                let newArr = this.eachDataFN(tRes,[])
                this.sendDataTreeLeft = newArr
                //右侧展示的名字和条数
                this.rightShowTreeInfo.name = newArr[0].name;
                //this.rightShowTreeInfo.count = newArr[0].count;
                this.loading.close()
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.bottomWrap{
    width: 1200px;
    margin: 0 auto;
    margin-top: 10px;
}
.showView{
    width:100%;
    box-sizing: border-box;
    margin-top:10px;
    display: flex;
}
/***顶部的路径 start */
.topPathView{
    width: 1200px;
    min-height: 50px;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.2);
    border-radius: 0px 0px 0px 0px;
    box-sizing: border-box;
    padding:10px 20px;
    font-size: 16px;
    color: #3D3D3D;
    p{
        line-height: 30px;
    }
}
/***顶部的路径 end */


/**左侧分类 start*/
.leftTreeView{
    width: 320px;
    overflow: hidden;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.2);
}

/**左侧分类 end*/


/**右侧内容 start*/
.rightContentView{
    width: calc(100% - 330px);
    /*overflow: hidden;*/
    margin-left:10px;
    .showTreeName{
        width: 100%;
        height: 48px;
        line-height: 48px;
        background: #003FA8;
        box-sizing: border-box;
        padding-left:20px;
        font-size: 20px;
        color:#ffffff;
        .treeCount{
            font-size: 16px;
        }
    }
    .dataBox{
        width:100%;
        overflow: hidden;
        background: #ffffff;
        margin-top:10px;
        box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.2);
    }
}
/**右侧内容 end*/

/***数据展示列表  end */

.divB{
    width:100%;
    height: 3px;
    background: #0F59A4;
}
.blueSpan{
    color:#003FA8!important;
}
.redSpan{
    color:#C22424!important;
}

</style>